"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconPayment', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 3C1.44771 3 1 3.44772 1 4L1 12C1 12.5523 1.44771 13 2 13L14 13C14.5523 13 15 12.5523 15 12L15 4C15 3.44772 14.5523 3 14 3L2 3ZM13 6V5H3L3 6H13ZM3 8H13V11H3L3 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11L12 11Z', 'M1 5C1 4.44772 1.44772 4 2 4L18 4C18.5523 4 19 4.44772 19 5V15C19 15.5523 18.5523 16 18 16L2 16C1.44772 16 1 15.5523 1 15L1 8.00165L1 8L1 7.99835L1 5ZM3 6L3 7L17 7V6L3 6ZM3 14L3 9H17V14L3 14Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.03 15.0001C14.4777 15.0001 14.03 15.4478 14.03 16.0001C14.03 16.5523 14.4777 17.0001 15.03 17.0001H19.03C19.5823 17.0001 20.03 16.5523 20.03 16.0001C20.03 15.4478 19.5823 15.0001 19.03 15.0001H15.03Z', 'M1.03003 5.00006C1.03003 4.44778 1.47775 4.00006 2.03003 4.00006L22.03 4.00006C22.5823 4.00006 23.03 4.44778 23.03 5.00006L23.03 19.0001C23.03 19.5523 22.5823 20.0001 22.03 20.0001L2.03003 20.0001C1.47775 20.0001 1.03003 19.5523 1.03003 19.0001L1.03003 5.00006ZM21.03 6.00006V8.00006L3.03003 8.00006L3.03003 6.00006L21.03 6.00006ZM21.03 10.0001L3.03003 10.0001L3.03003 18.0001H21.03V10.0001Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M22.4999 23H25.4999C26.3283 23 26.9999 22.3284 26.9999 21.5C26.9999 20.6716 26.3283 20 25.4999 20H22.4999C21.6715 20 20.9999 20.6716 20.9999 21.5C20.9999 22.3284 21.6715 23 22.4999 23Z', 'M1.43922 6.43934C1.72052 6.15804 2.10205 6 2.49988 6H29.4999C30.3283 6 30.9999 6.67157 30.9999 7.5V25.5C30.9999 26.3284 30.3283 27 29.4999 27H2.49988C1.67145 27 0.999878 26.3284 0.999878 25.5V7.5C0.999878 7.10218 1.15791 6.72064 1.43922 6.43934ZM3.99988 9V11H27.9999V9H3.99988ZM3.99988 24V14H27.9999V24H3.99988Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;